import { FieldType, CommandFieldSettings, RenderType } from "../types/availableCommand";


export function useCommandFieldConfig(fieldType: FieldType) {
  const defaultSettings = {
    helpText: true,
    renderType: 'input' as RenderType,
  };
  const settings: { [key in FieldType]: CommandFieldSettings } = {
    text: {
      ...defaultSettings,
      default: true,
      options: false,
      inputType: 'text',
    },
    select: {
      ...defaultSettings,
      default: true,
      options: true,
      renderType: 'select',
      inputType: 'select',
    },
    number: {
      ...defaultSettings,
      default: true,
      options: false,
      inputType: 'number',
    },
  };

  const fieldTypeSettings = settings[fieldType];
  
  return {
    showHelpText: fieldTypeSettings.helpText,
    showDefault: fieldTypeSettings.default,
    showOptions: fieldTypeSettings.options,
    renderType: fieldTypeSettings.renderType,
    inputType: fieldTypeSettings.inputType,
  };
}
